<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container" style="margin: auto;">
    <a class="navbar-brand" [routerLink]="'/dashboard/e-commerce'">
			<img src="assets/assets-template/image/logo3cortado.png"  alt="img-fluid" style="width: 15rem;">
		</a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()"
      [attr.aria-expanded]="!isCollapsed" [attr.aria-label]="isCollapsed ? 'Toggle navigation' : 'Close navigation'">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNav">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item active">
          <a class="nav-link" [routerLink]="'/dashboard/e-commerce'">Inicio <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/usuario/list-usuario'">Usuarios</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/categorias'">Categorías</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/cargos'">Cargos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/paginas'">Páginas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/banners'">Banners</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/enlaces'">Enlaces</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/alertas'">Alertas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/categorias-grupos'">Cats.-Grp.</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dashboard/paginas-grupos'">Págs.-Grp.</a>
        </li> -->
        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" role="button" id="navbarDropdown" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Cerrar Sesión
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" (click)="logout()">Cerrar Sesión</a>
          </div>
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" (click)="logout()">Cerrar Sesión</a>
        </li>
      </ul>
    </div>
  </div>
</nav> -->

<header class="header">
	<div class="main-menu sticky-header">
		<div class="main-menu-inner">
			<div class="main-menu-left">
				<div class="main-menu-logo" style="padding: 5px !important;">
					<a><img src="assets/assets-template/image/logo5.png"  alt="img-145" style="width: 13rem;"></a>
				</div><!--main-menu-logo-->
				<div class="navigation">
					<ul class="main-menu-list list-unstyled">
            <li>
              <a [routerLink]="'/dashboard/e-commerce'">Inicio</a>
            </li>
						<li class="has-dropdown">
							<a>Usuarios</a>
							<ul class="list-unstyled">
                <li>
                  <a [routerLink]="'/dashboard/usuario/list-usuario'">Usuarios</a>
                </li>
                <!-- <li>
                  <a [routerLink]="'/dashboard/categorias'">Categorías</a>
                </li> -->
                <li>
                  <a [routerLink]="'/dashboard/cargos'">Cargos</a>
                </li>
							</ul><!-- list-unstyled -->
						</li><!--has-dropdown-->

            <li class="has-dropdown">
              <a href="">Sliders</a>
              <ul class="list-unstyled">
                <li>
                  <a [routerLink]="'/dashboard/banners'">Banners</a>
                </li>
                <!-- <li>
                  <a [routerLink]="'/dashboard/enlaces'">Enlaces</a>
                </li> -->
                <li>
                  <a [routerLink]="'/dashboard/alertas'">Alertas</a>
                </li>
                <li>
                  <a [routerLink]="'/dashboard/videos'">Videos</a>
                </li>

              </ul>
            </li>
            <!-- <li>
              <a [routerLink]="'/dashboard/paginas'">Páginas</a>
            </li> -->

            <!-- <li>
              <a [routerLink]="'/dashboard/paginas-grupos'">Páginas</a>
            </li> -->
						<li class="has-dropdown">
							<a>Sitio Web</a>
							<ul class="list-unstyled">
                <li>
                  <a [routerLink]="'/dashboard/categorias-grupos'" *appHasRoles="['admin']">Categorias</a>
                </li>
                <li>
                  <a [routerLink]="'/dashboard/paginas-grupos'">Páginas</a>
                </li>
                <li>
                  <a [routerLink]="'/dashboard/ejecutivos'">Ejecutivos</a>
                </li>

							</ul>
						</li>
            <li class="has-dropdown">
							<a>Sesión</a>
							<ul class="list-unstyled">
                <li>
                  <a (click)="logout()">Cerrar Sesión</a>
                </li>

							</ul><!-- list-unstyled -->
						</li><!--has-dropdown-->
					</ul><!-- main-menu-list -->
				</div><!--navigation-->
			</div><!--main-menu-left-->
			<div class="main-menu-right">
				<div class="mobile-menu-button mobile-nav-toggler">
					<span></span>
					<span></span>
					<span></span>
				</div>
				<!-- <div class="search-box"> -->
					<!-- <a href="#" class="search-toggler">
						<i class="flaticon-search-interface-symbol"></i>
					</a> -->
					<!-- search-toggler -->
				<!-- </div> -->
				<!-- search-box -->
				<div style="padding-right: 30px;" class="main-menu-right-button">
					<a href="#"><img src="assets/assets-template/image/escudo.png" alt="img-145" style="height: 5rem;"></a>
				</div>
			</div><!--main-menu-right-->
		</div><!--main-menu-inner-->
	</div><!--main-menu-->
</header>
